import { ReactElement, useContext, useEffect } from 'react';

import { FirmwareOverviewModel } from '../../../../../../shared/models/firmware-overview.model';
import { getFirmwaresWithPagination } from '../../../../../../shared/thunks/get-firmwares-with-pagination/get-firmwares-with-pagination.thunk';
import Modal from '../../../../../shared/components/modal/Modal';
import { ModalContext } from '../../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { FirmwareHeaderAndPaginationFilters } from '../../../../models/firmware-header-and-pagination-filters.model';
import { deleteFirmware } from '../../../../thunk/delete-firmware.thunk';

export const useShowDeleteModalFirmwareTable = (
  ids: number[],
  firmwareFilters?: FirmwareHeaderAndPaginationFilters | undefined
): ReactElement => {
  const ctx = useContext(ModalContext) as ModalContextModel;

  const deleteModal = useDeleteModal<
    void,
    number,
    FirmwareOverviewModel[],
    Partial<FirmwareHeaderAndPaginationFilters> | undefined
  >({
    ids: ids,
    deleteAction: deleteFirmware,
    afterDeleteAction: getFirmwaresWithPagination,
    param: firmwareFilters,
  });

  useEffect(() => {
    if (ids.length && !ctx.isOpen) {
      ctx.componentHandler(deleteModal);
      ctx.modalStateHandler();
    }
  }, [ids]);

  return <Modal>{ctx.component}</Modal>;
};
